/**
 * url参数分割.
 *
 * @author yusangeng@outlook.com
 */
/**
 * 将url参数分割为键值对.
 *
 * @param {string} url search部分, 可以通过window.location.search取得.
 * @returns {KonphGlobal<T>} url参数表.
 * @private
 */
export default function split(searchStr) {
    var segments = searchStr.replace(/^\?/, "").split("&");
    return segments
        .map(function (el) {
        var _a = el.split("=", 2), key = _a[0], value = _a[1];
        key = key.trim().toLowerCase(); // 不分大小写
        if (!key.length) {
            return void 0;
        }
        value = decodeURIComponent(value || "").trim(); // value忽略两端空格
        return { key: key, value: value };
    })
        .reduce(function (prev, el) {
        if (el) {
            prev[el.key] = el.value;
        }
        return prev;
    }, {});
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BsaXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc3BsaXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7R0FJRztBQUlIOzs7Ozs7R0FNRztBQUNILE1BQU0sQ0FBQyxPQUFPLFVBQVUsS0FBSyxDQUMzQixTQUFpQjtJQUVqQixJQUFNLFFBQVEsR0FBRyxTQUFTLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSxFQUFFLENBQUMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7SUFFekQsT0FBTyxRQUFRO1NBQ1osR0FBRyxDQUFDLFVBQUEsRUFBRTtRQUNELElBQUEsS0FBZSxFQUFFLENBQUMsS0FBSyxDQUFDLEdBQUcsRUFBRSxDQUFDLENBQUMsRUFBOUIsR0FBRyxRQUFBLEVBQUUsS0FBSyxRQUFvQixDQUFDO1FBRXBDLEdBQUcsR0FBRyxHQUFHLENBQUMsSUFBSSxFQUFFLENBQUMsV0FBVyxFQUFFLENBQUMsQ0FBQyxRQUFRO1FBRXhDLElBQUksQ0FBQyxHQUFHLENBQUMsTUFBTSxFQUFFO1lBQ2YsT0FBTyxLQUFLLENBQUMsQ0FBQztTQUNmO1FBRUQsS0FBSyxHQUFHLGtCQUFrQixDQUFDLEtBQUssSUFBSSxFQUFFLENBQUMsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLGNBQWM7UUFFOUQsT0FBTyxFQUFFLEdBQUcsS0FBQSxFQUFFLEtBQUssT0FBQSxFQUFFLENBQUM7SUFDeEIsQ0FBQyxDQUFDO1NBQ0QsTUFBTSxDQUFDLFVBQUMsSUFBSSxFQUFFLEVBQUU7UUFDZixJQUFJLEVBQUUsRUFBRTtZQUNOLElBQUksQ0FBQyxFQUFFLENBQUMsR0FBYyxDQUFDLEdBQUcsRUFBRSxDQUFDLEtBQVksQ0FBQztTQUMzQztRQUVELE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQyxFQUFFLEVBQW9CLENBQUMsQ0FBQztBQUM3QixDQUFDIn0=